// Perheen yhteiskartta: palvelimen /api/family/tiles -vastaus piirrettävään muotoon.
//
// Vastaus: { zoom, players: [{id, name, color, emblem}], tiles: [[x, y, maski], ...] }
// Maskin bitti i on päällä, jos players[i] on kerännyt ruudun. Bittejä ei lueta
// operaattoreilla (>>, &), koska ne katkaisevat luvun 32 bittiin; jako toimii kaikille
// kokonaisluvuille, joita JSON voi kantaa.

const bitOn = (mask, i) => Math.floor(mask / 2 ** i) % 2 === 1;

/**
 * Piirrettävät ruudut ja selite.
 *
 * tiles:   [{ key: "z/x/y", color, shared, ids }]  (color on null yhteisille ruuduille)
 * legend:  [{ id, name, color, emblem, count }]    (ruutuja, jotka pelaaja on kerännyt)
 * shared:  montako ruutua on usean pelaajan keräämiä
 */
export function familyLayerData(data) {
  const players = data?.players ?? [];
  const legend = players.map((p) => ({ ...p, count: 0 }));
  const tiles = [];
  let shared = 0;
  for (const [x, y, mask] of data?.tiles ?? []) {
    const owners = []; // pelaajien indeksit, joilla on ruutu
    players.forEach((_, i) => {
      if (bitOn(mask, i)) owners.push(i);
    });
    if (!owners.length) continue; // tyhjä maski: ei kenenkään ruutu
    owners.forEach((i) => legend[i].count++);
    const isShared = owners.length > 1;
    if (isShared) shared++;
    tiles.push({
      key: `${data.zoom}/${x}/${y}`,
      color: isShared ? null : players[owners[0]].color,
      shared: isShared,
      ids: owners.map((i) => players[i].id),
    });
  }
  return { tiles, legend, shared };
}
